import { createStore, Provider } from 'jotai';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// routes
import Router from './routes/routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';

import "./assets/css/custom.css";


// ----------------------------------------------------------------------

export default function App() {
  const store = createStore();
  return (
    <Provider store={store}>
      
        <HelmetProvider>
          <BrowserRouter>
            <ThemeProvider>
              <ScrollToTop />
              <Router />
            </ThemeProvider>
          </BrowserRouter>
        </HelmetProvider>
    </Provider>
  );
}
